var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvatar = function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3451",
    fillRule: "evenodd",
    d: "M12 20.2a8.159 8.159 0 0 0 3.769-.916A5.328 5.328 0 0 0 12 17.729a5.33 5.33 0 0 0-3.77 1.555 8.165 8.165 0 0 0 3.744.916H12zm0-4.271c2.095 0 3.98.902 5.287 2.34A8.2 8.2 0 0 0 12 3.8a8.2 8.2 0 0 0-5.287 14.468A7.126 7.126 0 0 1 12 15.928zM22 12a9.986 9.986 0 0 1-4.31 8.224l-.05.034a9.946 9.946 0 0 1-6.155 1.729 9.94 9.94 0 0 1-5.809-2.24A9.98 9.98 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10zm-7.157-1.857a2.843 2.843 0 1 1-5.686 0 2.843 2.843 0 0 1 5.686 0zm1.8 0a4.643 4.643 0 1 1-9.287 0 4.643 4.643 0 0 1 9.287 0z",
    clipRule: "evenodd"
  })));
};
export default SvgAvatar;